<template>
    <el-tooltip :content="tooltipContent"
                placement="top">
        <icon-copy :class="iconClass">
        </icon-copy>
    </el-tooltip>
</template>

<script>

export default {
    name: "ModelReplicationTooltip",

    props: {
        replicationDetails: {
            type: Object,
            required: true,
            description: "Used to display the replication details"
        },
        iconClass: {
            type: String,
            default: "w-5 h-5 text-gray-400"
        }
    },

    computed: {
        tooltipContent () {
            return "Replicated from another team on " + this.$options.filters.date(this.replicationDetails.created_at) +
                (this.userHasRole("Support") ? " - Original Team Id: " + this.replicationDetails.external_client_id : "");
        }
    }
};
</script>
